import { createContext, useContext, useState, ReactNode } from "react";

const ADMIN_PIN = import.meta.env.VITE_ADMIN_PIN ?? "1234";
const SESSION_KEY = "aurora_admin_auth";

interface AdminAuthValue {
  isAuthenticated: boolean;
  login: (pin: string) => boolean;
  logout: () => void;
}

const AdminAuthContext = createContext<AdminAuthValue | null>(null);

export function AdminAuthProvider({ children }: { children: ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === "ok"
  );

  function login(pin: string): boolean {
    if (pin === ADMIN_PIN) {
      sessionStorage.setItem(SESSION_KEY, "ok");
      setIsAuthenticated(true);
      return true;
    }
    return false;
  }

  function logout() {
    sessionStorage.removeItem(SESSION_KEY);
    setIsAuthenticated(false);
  }

  return (
    <AdminAuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be inside AdminAuthProvider");
  return ctx;
}
